module.exports = __webpack_public_path__ + "static/media/Ron Piester Headshot.bcb99472.jpeg";